import { render } from "./PamiaWidget.vue?vue&type=template&id=47586da4&scoped=true"
import script from "./PamiaWidget.vue?vue&type=script&lang=js"
export * from "./PamiaWidget.vue?vue&type=script&lang=js"

import "./PamiaWidget.vue?vue&type=style&index=0&id=47586da4&scoped=true&lang=css"
import "./PamiaWidget.vue?vue&type=style&index=1&id=47586da4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47586da4"]])

export default __exports__